/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query RouteListQuery($search: String, $type: CUSTOMER_TYPE, $skip: Int) {
  RouteList(search: $search, type: $type, take: 10000, skip: $skip) {
    id,
    displayName,
    type,
    message,
    status
  }
}
`
